import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ylatxgszdrdsigzejhhq.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlsYXR4Z3N6ZHJkc2lnemVqaGhxIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDQ0MzY3MTcsImV4cCI6MTk2MDAxMjcxN30.dummy-key-for-development';

// Create Supabase client with dummy key for development
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface User {
  id: string;
  email: string;
  full_name: string;
  phone?: string;
  user_type: 'customer' | 'business' | 'admin';
  company_name?: string;
  created_at: string;
  updated_at: string;
}

export interface Address {
  id: string;
  user_id: string;
  label: string;
  street_address: string;
  city: string;
  postal_code: string;
  is_default: boolean;
  type: 'pickup' | 'delivery' | 'both';
  created_at: string;
}

export interface Order {
  id: string;
  order_number: string;
  user_id?: string;

  // Sender Information
  sender_name: string;
  sender_phone: string;
  sender_email: string;

  // Recipient Information
  recipient_name: string;
  recipient_phone: string;
  recipient_email?: string;

  // Pickup Details
  pickup_address: string;
  pickup_city: string;
  pickup_postal_code?: string;
  pickup_instructions?: string;
  pickup_date?: string;
  pickup_time?: string;

  // Delivery Details
  delivery_address: string;
  delivery_city: string;
  delivery_postal_code?: string;
  delivery_instructions?: string;
  delivery_date?: string;
  delivery_time?: string;

  // Service Information
  service_type: 'standard' | 'same_day' | 'rush' | 'direct';
  status: 'pending' | 'confirmed' | 'in_transit' | 'delivered' | 'cancelled';

  // Additional Options
  is_residential?: boolean;
  insurance_value?: number;
  declared_value?: number;

  // Pricing
  subtotal?: number;
  tax?: number;
  total_price: number;

  // Payment Information
  payment_intent_id?: string;
  payment_method?: string;
  payment_status?: 'pending' | 'paid' | 'failed' | 'refunded';

  // Tracking
  estimated_delivery?: string;
  delivered_at?: string;

  // Metadata
  created_at: string;
  updated_at?: string;

  // Relations (if populated)
  items?: OrderItem[];
  tracking_updates?: TrackingUpdate[];
}

export interface OrderItem {
  id: string;
  order_id: string;
  package_type: 'envelope' | 'small_box' | 'medium_box' | 'large_box' | 'xl_box';
  quantity: number;
  price: number;
}

export interface TrackingUpdate {
  id: string;
  order_id: string;
  status: string;
  location?: string;
  message: string;
  created_at: string;
}

export interface PricingMatrix {
  id: string;
  from_city: string;
  to_city: string;
  envelope_price: number;
  created_at: string;
  updated_at: string;
}